<template>
  <div :class="[$style.recoveryEmailContainer, $style.inputRow]">
    <div :class="[$style.flexSingleWidth, $style.recoveryEmailWrapper]">
      <InputValidator
        v-model="recoveryEmail.address"
        :class="$style.recoveryEmailInputValidator"
        :config="{
          attribute: 'recoveryEmail',
          name: 'Recovery Email',
          validate: `email|is_not:${companyEmail}`,
          value: recoveryEmail.address,
        }"
        data-test-id="recoveryEmailInputWrapper"
        @InputValidatorBlur="handleBlur"
        @InputValidatorModel="handleAddressChange"
      />
      <Tooltip
        v-if="recoveryEmail.verified"
        :class="$style.recoveryEmailVerified"
        data-test-id="recoveryEmailTooltip"
        hasIndicator
        isDark
        orientation="bottom"
        :text="getVerifiedAt()"
      >
        <Icon
          icon="checkmarkCircle"
          :scale="1.25"
        />
      </Tooltip>
    </div>
  </div>
</template>

<script>
import { Icon, Tooltip } from '@jumpcloud/ui-components';
import {
  dateDisplayFormat,
} from 'client/systemusers/constants/SystemUserConstants';
import DateUtil from 'client/util/DateUtil';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'PasswordRecoveryEmail',

  components: {
    Icon,
    InputValidator,
    Tooltip,
  },

  inject: ['$validator'],

  props: {
    companyEmail: {
      type: String,
      required: true,
    },
    handleValueChange: {
      type: Function,
      required: true,
    },
    recoveryEmail: {
      type: Object,
      required: true,
    },
  },

  vValidateDict: {
    custom: {
      'Recovery Email': {
        email: '* Please enter a valid email address.',
        is_not: '* Error, company email address already in use.',
      },
    },
  },

  mounted() {
    this.$validator.localize('en', this.$options.vValidateDict);
  },

  methods: {
    getVerifiedAt() {
      return `Verified ${DateUtil.customFormatDate(this.recoveryEmail.verifiedAt, dateDisplayFormat)}`;
    },

    handleAddressChange(value) {
      const address = value.trim();
      this.handleValueChange({ address }, 'recoveryEmail');
    },

    handleBlur(value) {
      // Return early if value is falsy or if address is verified and unchanged
      if (!value || (this.recoveryEmail.verified && this.recoveryEmail.address === value)) {
        return;
      }

      // Handle the edge case where the company email is entered with any uppercase letters
      const address = value.toLowerCase();

      this.handleAddressChange(address);

      // Ensures validation check after handling the value change
      setTimeout(() => this.$validator.validate('Recovery Email'));
    },
  },
};
</script>

<style module>
@import '../../css/flex.css';
@import '../../components/FormValidation/css/formFields.css';

@value (max-width-x-large) from '~css/breakpoints.css';

.recoveryEmailContainer {
  width: calc(50% - 10px);
}

.recoveryEmailWrapper {
  position: relative;
}

.recoveryEmailInputValidator {
  z-index: 0;
}

.recoveryEmailVerified {
  background-color: var(--jcWhite);
  color: var(--jcSuccess);
  cursor: default !important;
  position: absolute !important;
  right: 9px;
  top: 13px;
}

@media (max-width: max-width-x-large) {
  .recoveryEmailContainer {
    width: 100%;
  }
}
</style>
